import { Label } from '@perch-labs/shrike';
import { randomNumber } from '@perch-labs/warbler';
import copyToClipboard from 'copy-to-clipboard';
import { Button } from '~/components/button';
import { Container } from '~/components/layout';
import { autofill } from './dev-tools.component';

type Props = {
  isConEd: boolean;
  next: (data: any) => void;
  utilityId: number;
  isSponsoredSolar?: boolean;
  isPerchEnergy?: boolean;
};

export const CredentialsStatus = ({
  isConEd,
  next,
  utilityId,
  isSponsoredSolar,
  isPerchEnergy,
}: Props) => {
  // We use the `verified` event to simulate an invalid scraper response because,
  // in this case, the scraper does not return any data.
  // This workaround is necessary as there is no direct way to mock the invalid scraper response
  // as it is a service call, and not an event.
  // ref: src/machines/perch-energy/machine.ts file and fetchScraperDetailsValidity state
  // This will allow us to go to the fallback multiple account number screen since the scraper will not return any UA data.
  const handleInvalidScraperResponse = () => next({ utilityConnectStatus: 'verified' });

  return (
    <Container maxWidth="250px">
      {isConEd ? (
        <Button mode="primary" onClick={() => copyToClipboard(`2${randomNumber(14)}`)} mb={1}>
          Copy account number
        </Button>
      ) : (
        <>
          <Button
            mode="primary"
            onClick={() => copyToClipboard(`staging${randomNumber(10)}@arcadia.com`)}
            mb={1}
          >
            Copy username
          </Button>
          <Button mode="primary" onClick={() => copyToClipboard(`pw-${randomNumber(10)}`)} mb={1}>
            Copy password
          </Button>
          <Button mode="primary" onClick={() => autofill({ utilityId })}>
            Autofill account #
          </Button>
        </>
      )}
      {!isSponsoredSolar && (
        <>
          <Label margin={{ bottom: '16px', top: '16px' }}>Or simulate response:</Label>
          <Button
            mode="outline"
            mb={1}
            onClick={() => next({ utilityConnectStatus: 'verified' })}
            size="small"
          >
            Verified
          </Button>
          {isPerchEnergy ? (
            <Button mode="outline" mb={1} onClick={handleInvalidScraperResponse} size="small">
              Invalid scraper response
            </Button>
          ) : null}
          <Button
            mode="default"
            mb={1}
            onClick={() => next({ utilityConnectStatus: 'timed_out' })}
            size="small"
          >
            Timed out
          </Button>
          <Button
            mode="destructive"
            mb={1}
            onClick={() => next({ utilityConnectStatus: 'rejected' })}
            size="small"
          >
            Rejected
          </Button>
          <Button
            mode="destructive"
            mb={1}
            onClick={() => next({ utilityConnectStatus: 'error' })}
            size="small"
          >
            Error
          </Button>
        </>
      )}
    </Container>
  );
};
